<template>
  <div class="main-container">
    <div class="input-container">
      <label class="text-center">Wybierz kategorię</label>
      <select v-model="serviceCategory" required class="form-control mb-5">
        <option disabled :value="null">Wybierz kategorię</option>
        <option
          :value="serviceCategory.id"
          v-for="serviceCategory in serviceCategoriesWithServices"
          :key="serviceCategory.id"
        >
          {{ serviceCategory.name }}
        </option>
      </select>
    </div>
    <form class="topform mt-5" @submit="handleSubCategoryCreate($event)">
      <div class="multiple-inputs">
        <div class="input-container">
          <label>Nazwa podkategorii (np. TEST_SUBCATEGORY):</label>
          <input
            v-model="name"
            id="name"
            class="form-control"
            type="text"
            required
            minlength="1"
          />
        </div>
        <div class="input-container">
          <label>Nazwa wyświetlana (np. Podkategoria testowa):</label>
          <input
            v-model="displayName"
            id="displayName"
            type="text"
            class="form-control"
            required
            minlength="1"
          />
        </div>
      </div>
      <button
        v-if="serviceCategory && name.length > 0 && displayName.length > 0"
        class="buttonm btn btn-outline-dark"
        type="submit"
      >
        Dodaj
      </button>
    </form>
    <table
      class="table table-striped table-sm serviceTable"
      v-if="this.subCategories && this.subCategories.length > 0"
    >
      <thead>
        <tr class="tr-table">
          <th scope="col">ID podkategorii</th>
          <th scope="col">Nazwa</th>
          <th scope="col">Nazwa wyświetlania</th>
          <th scope="col">Id kategorii</th>
          <th scope="col">Nazwa kategorii</th>
          <th scope="col">Ukryj</th>
          <th scope="col">Ikony</th>
          <th scope="col">Edycja</th>
          <th scope="col">Usuń</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in subCategories" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.display_name }}</td>
          <td>{{ item.service_category.id }}</td>
          <td>{{ item.service_category.name }}</td>
          <td>
            <span class="toggle">
              <p v-if="item.is_hidden">Tak</p>
              <i
                class="fas fa-toggle-on"
                v-if="item.is_hidden"
                @click="handleToggleIsHidden(item.id, !item.is_hidden)"
              ></i>
              <p v-if="!item.is_hidden">Nie</p>
              <i
                class="fas fa-toggle-off"
                v-if="!item.is_hidden"
                @click="handleToggleIsHidden(item.id, !item.is_hidden)"
              ></i>
            </span>
          </td>
          <td>
            <button
              v-if="item.icon_svg !== 'no-photo.png' && item.icon_svg"
              @click="showIcon(item.icon_svg, 'svg')"
              class="iconLink"
              :data-target="`#iconModal${item.id}`"
              data-toggle="modal"
            >
              <img
                :src="
                  getUrl() + `/api/service/get-icon-by-name/${item.icon_svg}`
                "
                :id="`${item.id}svg`"
              />
              <span class="iconName">SVG </span>
            </button>
            <button
              v-if="item.icon_png !== 'no-photo.png' && item.icon_png"
              @click="showIcon(item.icon_png, 'png')"
              class="iconLink"
              :data-target="`#iconModal${item.id}`"
              data-toggle="modal"
            >
              <img
                :src="
                  getUrl() + `/api/service/get-icon-by-name/${item.icon_png}`
                "
                :id="`${item.id}png`"
              />

              <span class="iconName">WEBP</span>
            </button>
            <div>
              <label
                class="inputButtonLabel btn-outline-dark"
                :for="`file-input-icon${item.id}`"
                >Dodaj/Edytuj</label
              >
              <input
                type="file"
                accept=" image/svg+xml, image/webp"
                @change="
                  uploadIcon(
                    $event,
                    item.id,
                    `/api/service/get-icon-by-name/${item.icon_png}`
                  )
                "
                :id="`file-input-icon${item.id}`"
                hidden
              />
            </div>
          </td>

          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#editModal"
              v-on:click="setSubCategoryToEdit(item)"
            >
              Edytuj
            </button>
          </td>
          <td>
            <button
              class="btn btn-outline-dark"
              v-on:click="deleteSubCategory(item)"
            >
              x
            </button>
          </td>
          <div
            class="modal fade"
            :id="`iconModal${item.id}`"
            tabindex="-1"
            role="dialog"
            aria-labelledby="iconModal"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header iconModal">
                  <h5 class="modal-title" id="iconModal">Ikona usługi</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    style="color: white"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body iconModal">
                  <img
                    class="iconImg"
                    v-if="iconExtension === 'svg'"
                    :src="`data:image/svg+xml;base64,${iconBase64ToDisplay}`"
                  />
                  <img
                    class="iconImg"
                    v-else
                    :src="`data:image/webp;base64,${iconBase64ToDisplay}`"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade"
            id="editModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="editModal"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="editModalLabel">
                    Edytuj podkategorię
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="input-container">
                    <label class="text-center">Wybierz kategorię</label>
                    <select
                      v-model="subCategoryServiceCategoryToEdit"
                      required
                      class="form-control mb-5"
                    >
                      <option disabled :value="null">Wybierz kategorię</option>
                      <option
                        :value="serviceCategory.id"
                        v-for="serviceCategory in serviceCategoriesWithServices"
                        :key="serviceCategory.id"
                      >
                        {{ serviceCategory.name }}
                      </option>
                    </select>
                  </div>
                  <form
                    class="topform mt-5"
                    @submit="handleSubCategoryEdit($event)"
                  >
                    <div class="multiple-inputs">
                      <div class="input-container">
                        <label
                          >Nazwa podkategorii (np. TEST_SUBCATEGORY):</label
                        >
                        <input
                          v-model="subCategoryNameToEdit"
                          id="name"
                          class="form-control"
                          type="text"
                          required
                          minlength="1"
                        />
                      </div>
                      <div class="input-container">
                        <label
                          >Nazwa wyświetlana (np. Podkategoria testowa):</label
                        >
                        <input
                          v-model="subCategoryDisplayNameToEdit"
                          id="displayName"
                          type="text"
                          class="form-control"
                          required
                          minlength="1"
                        />
                      </div>
                    </div>
                    <button
                      v-if="
                        subCategoryServiceCategoryToEdit &&
                          subCategoryNameToEdit.length > 0 &&
                          subCategoryDisplayNameToEdit.length > 0
                      "
                      class="buttonm btn btn-outline-dark"
                      type="submit"
                    >
                      Zapisz
                    </button>
                  </form>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "../../axios";
import { URL } from "../../axios";
//import shared from "../../shared";
export default {
  name: "create-service",
  created() {
    this.$store.dispatch("fetchServiceCategoriesWithServices");
    this.$store.dispatch("getAllSubCategories");
  },
  computed: {
    serviceCategoriesWithServices() {
      return this.$store.getters.getServiceCategoryWithServices;
    },
    subCategories() {
      return this.$store.getters.getAllSubCategories;
    },
  },

  data: function() {
    return {
      name: "",
      displayName: "",
      serviceCategory: null,
      subCategoryIdToEdit: "",
      subCategoryNameToEdit: "",
      subCategoryDisplayNameToEdit: "",
      subCategoryServiceCategoryToEdit: null,
      iconBase64ToDisplay: "",
      iconToUpload: null,
      iconExtension: null,
    };
  },
  methods: {
    async handleToggleIsHidden(id, hidden) {
      await this.$store.dispatch("editSubCategory", {
        id: id,
        is_hidden: hidden,
      });
      this.$store.dispatch("fetchServiceCategoriesWithServices");
      this.$store.dispatch("getAllSubCategories");
    },
    async uploadIcon(event, id) {
      let that = this;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = function(e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = async function() {
          var height = this.height;
          var width = this.width;
          const extension = event.target.files[0].name.split(".").pop();
          if (
            (extension === "svg" && width === 700 && height === 700) ||
            (extension === "webp" && width === 2800 && height === 2800)
          ) {
            const url = `api/subCategory/${id}/icon`;
            const config = {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            };
            const formData = new FormData();
            formData.append(
              "file",
              event.target.files[0],
              event.target.files[0].name
            );

            await axios
              .put(url, formData, config)
              .then(() => {
                if (extension === "webp") {
                  document.getElementById(`${id}png`).src =
                    URL +
                    `/api/service/get-icon-by-name/${id}.webp?change=${new Date().getTime()}`;
                } else {
                  document.getElementById(`${id}svg`).src =
                    URL +
                    `/api/service/get-icon-by-name/${id}.svg?change=${new Date().getTime()}`;
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            if (extension === "svg") {
              that.$notify({
                group: "error",
                text: "Ikona .svg musi być o rozmiarze 700x700",
              });
            } else {
              that.$notify({
                group: "error",
                text: "Ikona .webp musi być o rozmiarze 2800x2800",
              });
            }
          }
        };
      };
    },

    getUrl() {
      return URL;
    },
    async showIcon(icon, extension) {
      this.iconBase64ToDisplay = "";
      this.iconExtension = extension;
      await axios
        .get(`api/service/get-icon-by-name/${icon}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.iconBase64ToDisplay = Buffer.from(
            response.data,
            "binary"
          ).toString("base64");
        });
    },
    async deleteSubCategory(subCategory) {
      const confirmed = prompt(
        `Czy na pewno chcesz usunąć podkategorię ${subCategory.name}? Potwierdź wpisując nazwę usługi`,
        ""
      );
      if (confirmed === subCategory.name) {
        await this.$store.dispatch("deleteSubCategory", {
          id: subCategory.id,
        });
        this.$notify({
          group: "success",
          text: "Pomyslnie usunięto podkategorię",
        });
      }
    },
    setSubCategoryToEdit(subCategory) {
      this.subCategoryIdToEdit = subCategory.id;
      this.subCategoryNameToEdit = subCategory.name;
      this.subCategoryDisplayNameToEdit = subCategory.display_name;
      this.subCategoryServiceCategoryToEdit = subCategory.service_category.id;
    },

    async handleSubCategoryEdit(e) {
      e.preventDefault();
      const confirmed = confirm("Czy na pewno chcesz edytować podkategorię?");
      if (!confirmed) {
        return;
      }

      try {
        await this.$store.dispatch("editSubCategory", {
          id: this.subCategoryIdToEdit,
          name: this.subCategoryNameToEdit,
          displayName: this.subCategoryDisplayNameToEdit,
          serviceCategoryId: this.subCategoryServiceCategoryToEdit,
        });
        this.subCategoryNameToEdit = "";
        this.subCategorydisplayNameToEdit = "";
        this.subCategoryServiceCategoryToEdit = null;
        this.$notify({
          group: "success",
          text: "Pomyslnie edytowano podkategorię",
        });
      } catch (e) {
        this.$notify({
          group: "error",
          text: "Nie udało się edytować podkategorii",
        });
        console.log(e);
      }
    },

    async handleSubCategoryCreate(e) {
      e.preventDefault();
      const confirmed = confirm("Czy na pewno chcesz dodać podkategorię?");
      if (!confirmed) {
        return;
      }

      try {
        await this.$store.dispatch("addSubCategory", {
          name: this.name,
          displayName: this.displayName,
          serviceCategoryId: this.serviceCategory,
        });
        this.name = "";
        this.displayName = "";
        this.serviceCategory = null;
        this.$notify({
          group: "success",
          text: "Pomyslnie dodano podkategorię",
        });
      } catch (e) {
        this.$notify({
          group: "error",
          text: "Nie udało się dodać podkategorii",
        });
        console.log(e);
      }
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
button.btn {
  margin-top: 20px;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
.multiple-inputs {
  display: flex;
  justify-content: center;
}
.input-container {
  flex: 1;
  font-size: 15px;
}
.input-container label {
  font-size: 15px;
}

.main-container {
  margin: 0 auto;
  max-width: 1000px;
}

.main-container .form-control {
  margin: 0 auto;
  max-width: 400px;
}
.newCategoryForm {
  margin-bottom: 50px;
}
.newCategoryForm div input,
.newCategoryForm div textarea,
.form-control,
.newCategoryForm button {
  width: 400px;
  margin: 0;
}

img {
  max-height: 20px;
  height: 100%;
  width: auto;
}
.iconImg {
  width: 130px;
  max-height: 130px;
  padding: 25px;
}

.iconModal {
  background: #090741;
  color: white;
  outline: #fb8928;
}
.iconLink {
  margin-bottom: 6px;
  background: white;
  border-radius: 4px;
  border: 1px solid grey;
  width: 40px;
  margin: 3px;
  background: #090741;
  color: white;
}
.iconLink img {
  color: white;
  margin: 0 auto;
}
.iconLink:hover {
  color: #fb8928;
  cursor: pointer;
}
.inputButtonLabel {
  cursor: pointer;
}
.inputButtonLabel:hover {
  background: rgb(49, 45, 45);
  color: white;
}
.serviceTable:hover,
tr:hover {
  cursor: default !important;
}
div.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 3%;
  margin-bottom: 20px;
}

.input-container label {
  margin: 10px 0px 0px 0px;
}
.inputButtonLabel {
  padding: 5px;
  border-radius: 5px;
}
.toggle {
  margin-right: 10px;
  display: flex;
  justify-content: center;
}
.toggle i {
  margin-left: 1rem;
  font-size: 18px;
  cursor: pointer;
}
</style>
